/* ============================================================
   トップページ FV（作品動画 × 商品）のスライダー
   マークアップは snippets/samansa-home-fv.liquid が出力する。
   ・横スワイプ / ドット / 左右矢印（PC）で切り替え、7 秒ごとに自動送り
   ・表示中のスライドの動画だけ再生、ほかは停止
   ・タッチ中は自動送りを止め、離して 2.5 秒後に再開
   ・FV が画面外に出たら動画と自動送りを止める
   ・ティッカー＋ヘッダーの高さを測り、FV を画面の残りいっぱいにする
   ============================================================ */
(function () {
  function init() {
    var fv = document.getElementById('shop-hero');
    var track = document.getElementById('nfvTrack');
    var dotsEl = document.getElementById('nfvDots');
    if (!fv || !track || !dotsEl || !fv.classList.contains('nfv')) return;

    var slides = Array.prototype.slice.call(track.querySelectorAll('.nfv-slide'));
    var bars = Array.prototype.slice.call(dotsEl.querySelectorAll('button'));
    if (!slides.length) return;
    var videos = slides.map(function (s) { return s.querySelector('video'); });
    var products = slides.map(function (s) { return s.querySelector('.nfv-product'); });
    var current = -1, timer = null, resumeTimer = null;
    var DURATION = parseFloat(getComputedStyle(fv).getPropertyValue('--nfv-dur')) * 1000 || 7000;

    /* ティッカー＋ヘッダーの高さを実測。ヘッダーが透過（fixed）なら FV に重なる分として別に持つ */
    function fitHeight() {
      var top = 0;
      var t = document.querySelector('.samansa-ticker');
      var h = document.querySelector('.samansa-shop-header');
      if (t) top += t.offsetHeight;
      var overlay = h && getComputedStyle(h).position === 'fixed';
      if (h && !overlay) top += h.offsetHeight;
      fv.style.setProperty('--nfv-top', top + 'px');
      fv.style.setProperty('--nfv-hdr', (overlay ? h.offsetHeight : 0) + 'px');
    }

    /* ドットを商品画像の直下に置く */
    function placeDots() {
      var p = products[current < 0 ? 0 : current];
      var frame = p && p.querySelector('.nfv-frame');
      if (!frame) return;
      var pr = frame.getBoundingClientRect();
      var fr = fv.getBoundingClientRect();
      dotsEl.style.top = (pr.bottom - fr.top + 20) + 'px';
    }

    function playVideo(v) {
      if (!v) return;
      v.preload = 'auto';
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function setActive(i) {
      if (i === current) return;
      current = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      bars.forEach(function (b) { b.classList.remove('now'); });
      if (bars[i]) { void bars[i].offsetWidth; bars[i].classList.add('now'); }
      videos.forEach(function (v, k) {
        if (!v) return;
        if (k === i) playVideo(v); else v.pause();
      });
      var next = videos[(i + 1) % videos.length];
      if (next) next.preload = 'auto';
      placeDots();
      restart();
    }

    function goTo(i) {
      var n = (i + slides.length) % slides.length;
      var w = track.clientWidth;
      if (!w) { setActive(n); return; }
      try { track.scrollTo({ left: n * w, behavior: 'smooth' }); }
      catch (e) { track.scrollLeft = n * w; }
    }

    function restart() {
      clearTimeout(timer);
      if (fv.classList.contains('is-paused')) return;
      timer = setTimeout(function () { goTo(current + 1); }, DURATION);
    }

    function refresh() { var c = current; current = -1; setActive(c < 0 ? 0 : c); }

    /* スクロール位置からアクティブ判定（商品画像はスライドと一緒にそのまま流れる） */
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth;
        if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current) setActive(i);
      });
    }, { passive: true });

    function pause() { fv.classList.add('is-paused'); clearTimeout(timer); clearTimeout(resumeTimer); }
    function resume() {
      clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () { fv.classList.remove('is-paused'); refresh(); }, 2500);
    }
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', resume, { passive: true });
    track.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') pause(); });
    track.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') resume(); });

    bars.forEach(function (b, k) { b.addEventListener('click', function () { goTo(k); }); });
    var prevBtn = document.getElementById('nfvPrev');
    var nextBtn = document.getElementById('nfvNext');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { fv.classList.remove('is-paused'); refresh(); }
        else { pause(); videos.forEach(function (v) { if (v) v.pause(); }); }
      }, { threshold: 0.25 }).observe(fv);
    }

    fitHeight();
    window.addEventListener('resize', function () { fitHeight(); placeDots(); });
    window.addEventListener('load', function () { fitHeight(); placeDots(); });
    setActive(0);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
